import React, { useEffect, useState } from "react";
import { Grid, Tabs, Tab, Typography } from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import CardGiftcardIcon from "@material-ui/icons/CardGiftcard";
import SettingsIcon from "@material-ui/icons/Settings";
import useThemeContext from "../../hooks/useThemeSwitch.js";
import { useFeatureFlag } from "../../hooks/useFeatureFlags";
import useHasPermissions from "../../hooks/useHasPermissions";
import { setRootContainerWidth } from "../../reducers/layout/layoutReducer.js";
import { useStyles } from "./styles.js";
import OneParkAdminContainer from "../../components/OneParkAdmin/OneParkAdminContainer.jsx";
import OneParkAccountContainer from "../../components/OneParkAccount/OneParkAccountContainer.jsx"
import OneParkInviteContainer from "../../components/OneParkInvite/OneParkInviteContainer.jsx"
import RewardGroupsContainer from "../../components/OneParkRewardGroups/RewardGroupsContainer.jsx";
import { useLocation } from "react-router-dom";

const OneParkAdminPage = () => {
  const classes = useStyles();
  const { layoutReducer } = useThemeContext();
  const [, layoutDispatch] = layoutReducer;
  const location = useLocation();
  const isOneParkEnabled = useFeatureFlag("ONEpark");
  const isRewardsEnabled = useFeatureFlag("ONEpark.Rewards");
  const { hasPermissions } = useHasPermissions();
  const hasOneParkPermission = hasPermissions(["ONEparkAdmin"]);
  const canAccessOnePark = isOneParkEnabled && hasOneParkPermission;

  const[selectedTab, setSelectedTab] = useState(location.state?.selectedTab || "tabAccount")

  useEffect(() => {
    layoutDispatch({ type: setRootContainerWidth, payload: false });
  }, [layoutDispatch]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <>
      {canAccessOnePark && (
        <>
          <Grid item xs={12}>
            <Tabs
              centered
              className={classes.oneParkTab}
              variant="fullWidth"
              value={selectedTab}
              onChange={handleTabChange}
            >
              <Tab
                value="tabAccount"
                className="onepark-account-tab-btn"
                icon={<PersonIcon />}
                label="Account"
                data-testid="onepark-account-tab"
              />
              <Tab
                value="tabInvite"
                icon={<MailOutlineIcon />}
                label="Invite"
                data-testid="onepark-invite-tab"
              />
              <Tab
                value="tabRewardGroups"
                className="onepark-rewards-group-tab-btn"
                icon={<CardGiftcardIcon />}
                label="Reward Groups"
                style={!isRewardsEnabled ? { display: "none" } : undefined}
                data-testid="onepark-reward-groups-tab"
              />
              <Tab
                value="tabAdmin"
                className="onepark-admin-tab-btn"
                icon={<SettingsIcon />}
                label="Admin"
                data-testid="onepark-admin-tab"
              />
            </Tabs>
          </Grid>

          {selectedTab === "tabAccount" && (
            <Grid item xs={12}>
              <OneParkAccountContainer />
            </Grid>
          )}

          {selectedTab === "tabInvite" && (
            <Grid item xs={12}>
              <OneParkInviteContainer />
            </Grid>
          )}

          {selectedTab === "tabRewardGroups" && isRewardsEnabled && (
            <Grid item xs={12}>
              <RewardGroupsContainer />
            </Grid>
          )}

          {selectedTab === "tabAdmin" && (
            <Grid item xs={12}>
              <Typography variant="subtitle1" className={classes.subHeader}>
                ONEpark Admin
              </Typography>
              <OneParkAdminContainer />
            </Grid>
          )}
        </>
      )}
    </>
  );
};

export default OneParkAdminPage;
